import CityLanding from "@/pages/CityLanding";

const CITY = {
    slug: "staugustine",
    name: "St. Augustine",
    shortName: "St. Aug",
    zipHint: "St. Johns County — 32080 to 32095",
    landmarkPhrase: "your home near the Bridge of Lions or a suite off A1A",
    introCopy:
        "The nation's oldest city deserves the newest kind of beauty service. From historic downtown weddings to Vilano Beach getaways, we come to you with unlimited gel or acrylic sets, AI 3D nail art, spray tans, and same-day availability.",
    whyCopy:
        "St. Augustine's cobblestone streets are for strolling, not searching for parking near a salon. Whether you're getting ready in a Casa Monica suite, hosting a bridal party in Anastasia Island, or squeezing in a fill before a wedding on Flagler College's lawn, our mobile studio is at your door — with patent-pending AI 3D nail art and salon-grade tools in tow.",
    neighborhoods: [
        "Historic Downtown",
        "Anastasia Island",
        "Vilano Beach",
        "St. Augustine Beach",
        "Davis Shores",
        "World Golf Village",
        "Nocatee",
        "Crescent Beach",
    ],
    nearby: ["Palm Coast", "Hastings", "St. Johns", "Elkton"],
};

export default function StAugustine() {
    return <CityLanding city={CITY} />;
}
